import { render, staticRenderFns } from "./AppColumnChart.vue?vue&type=template&id=10aaab87&scoped=true&"
import script from "./AppColumnChart.vue?vue&type=script&lang=js&"
export * from "./AppColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaab87",
  null
  
)

export default component.exports